import {globalWindow} from '../../libs/shared/core/src/helpers/browser/browserHelpers';
import {tryParseUrl} from '../../libs/shared/core/src/helpers/browser/urlHelpers';
import {isElectron} from '../../libs/shared/core/src/helpers/environment/platformHelpers';
import {openExternalUrl} from '../../src/services/electron/electronBridgeOutbound';
import {tryRenderOpenInBrowserInterstitial} from './openInBrowserInterstitial';

/** Open any URL in a browser. */
export function openInBrowser(url: string) {
  // Desktop app, standalone.
  if (isElectron()) {
    openExternalUrl(url);
    return;
  }

  // Web, HTTP(S).
  const protocol = tryParseUrl(url)?.protocol;
  if (protocol === 'https:' || protocol === 'http:') {
    globalWindow.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  // Web, non-HTTP(S).
  const newWindow = globalWindow.open();
  if (!newWindow) {
    return;
  }

  // Show an interstitial to avoid a blank tab, which can stick around forever for protocols like mailto.
  const {document} = newWindow;
  const container = document.createElement('div');
  document.body.appendChild(container);
  tryRenderOpenInBrowserInterstitial(container, url);

  newWindow.opener = null;
  newWindow.location.href = url;
}
